import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button, Stack, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { AddBoxOutlined, Edit, Info } from "@mui/icons-material";

import { ColumnDialogMode, ColumnDialogParams } from "components/tables/columns/ColumnModel";


interface DataTableToolbarProps {
  categoryLabel: string | undefined;
  children?: ReactNode;
  onColumnDialogMode: (params: ColumnDialogParams) => void;
}

export default function DataTableToolbar(props: DataTableToolbarProps) {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(700));

  return (
    <>
      <Stack
        direction="row"
        sx={{
          width: "100%",
          justifyContent: isSmallScreen ? "space-between" : "center"
        }}>
        <Stack direction="row" sx={{
          alignItems: "center"
        }}>
          <Tooltip title={(i18n.t("tables.base-column-def"))}>
            <Stack
              direction="row"
              sx={{
                alignItems: "center",
                gap: 1
              }}>
              <Info />
              <div>{i18n.t("tables.base-column")}:</div>
            </Stack>
          </Tooltip>
          <Button
            endIcon={<Edit />}
            onClick={() => {
              props.onColumnDialogMode && props.onColumnDialogMode({ mode: ColumnDialogMode.UPDATE_CATEGORY });
            }}
          >
            {props.categoryLabel}
          </Button>
        </Stack>
        <Button
          color="success"
          variant="contained"
          startIcon={<AddBoxOutlined />}
          sx={{ position: isSmallScreen ? "unset" : "absolute", right: theme.spacing(1), marginRight: 1 }}
          onClick={() => {
            props.onColumnDialogMode && props.onColumnDialogMode({ mode: ColumnDialogMode.ADD_COLUMN });
          }}
        >
          {i18n.t("tables.add-column")}
        </Button>
      </Stack>
      {props.children}
    </>
  );
}